<template>
    <div @click.self="$emit('close')" class="backdrop-blur-[7px] fixed w-full h-[130%] top-[-70px] mt-[-10px] z-10" style="background-color: rgba(53, 53, 53, 0.10)"></div>
    <div
        class="bg-[#252526] w-[500px] rounded-[10px] p-[14px] z-20 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] ml-[100px] border-[1px] border-[#FFF] border-opacity-10"
        style="box-shadow: 4px 4px 4px 0px #00000040;"
    >
        <div class="font-semibold text-center px-[20px] text-[16px] text-[#fff] leading-[19px] mb-[10px]">
            Редагувати опис: {{ file?.file_name }}
        </div>
        <div class="mb-[10px]">
            <div class="text-[#8C8C8C] font-medium text-[14px] mb-1">Опис</div>
            <textarea
                v-model="description"
                class="w-full border-[1px] border-[#9E9E9E] rounded-[6px] text-[#fff] bg-[#474849] bg-opacity-20 py-[5px] pl-[5px] outline-none"
                rows="4"
                placeholder="Опис файлу"
            ></textarea>
        </div>
        <div class="flex justify-center gap-3">
            <button
                @click="save"
                :disabled="saving"
                class="bg-[#8FC408] hover:bg-[#7ab307] disabled:opacity-50 disabled:cursor-not-allowed text-white w-[140px] font-medium h-[36px] rounded-[5px]"
            >
                {{ saving ? 'Збереження...' : 'Зберегти' }}
            </button>
            <button
                @click="$emit('close')"
                class="bg-[#474849] hover:bg-[#5a5a5b] text-white w-[140px] font-medium h-[36px] rounded-[5px]"
            >
                Скасувати
            </button>
        </div>
    </div>
</template>

<script>
    import { ref, watch } from 'vue'
    import { updateFileDescription } from '../services/apiRequests'

    export default {
        name: 'edit-description-modal',

        props: {
            file: {
                type: Object,
                default: null
            }
        },

        emits: ['close', 'updated'],

        setup(props, { emit }) {
            const description = ref('')
            const saving = ref(false)

            watch(() => props.file, (f) => {
                description.value = f?.description || ''
            }, { immediate: true })

            const save = async () => {
                if (!props.file?.id || saving.value) return
                saving.value = true
                try {
                    await updateFileDescription(props.file.id, description.value)
                    emit('updated')
                    emit('close')
                } catch (err) {
                    console.error('Update failed:', err)
                } finally {
                    saving.value = false
                }
            }

            return { description, saving, save }
        }
    }
</script>
